/*
 *@providesModule ChatConstants
 *
 */

/* eslint-disable no-magic-numbers */

/* All unchanging consts for chat */
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import {Platform} from 'react-native';

/* Route Names */
export const CHAT_LOBBY_ROUTE = 'ChatLobby';

/* Chat Cells */
export const CONTENT_HORIZONTAL_PADDING = 20;

/* ChatMessages */
export const MESSAGE_BOTTOM_MARGIN = 5.4;
export const SCALING_CELL_HEIGHT = 80;
export const TOURNAMENT_CELL_HEIGHT_XXLG = 125; // The xxlg height from MatchSelectCellStyle

/* ChatInputBar */
export const SUGGESTIONS_ROW_HEIGHT = 45;
export const BACKGROUND_PADDING = 40;
export const MAX_VISIBLE_INPUT_ROW_COUNT = 3; // Input rows
export const MAX_VISIBLE_ROW_COUNT = Sizes.isPhone() && Sizes.isLandscape() ? 1 : 5; // Suggestions rows
export const MENTIONS_URL = 'chat/notifications/users';

export const AUTOCORRECT_DELAY = 300; // for this https://github.com/facebook/react-native/issues/2552

/* ChatRoomView */
export const CHAT_LOAD_BUFFER_HEIGHT = Sizes.select({
  phone: 48,
  tablet: 64,
});

export const IPHONEX_PORTRAIT_OFFSET = -22;
export const IPHONEX_LANDSCAPE_OFFSET = -17;

export const TEXT_INPUT_MARGIN = 10;
export const TEXT_INPUT_PLATFORM_OFFSET = Platform.OS === 'android' ? 30 : 16;
export const TEXT_INPUT_MIN_HEIGHT = Math.max(
  16 +
    (Sizes.isTablet()
      ? SkillzStyle.fullStyles.fontSizeH2.fontSize
      : SkillzStyle.fullStyles.fontSizeH4.fontSize),
  34
);
export const TEXT_INPUT_MAX_HEIGHT =
  (Sizes.isTablet()
    ? SkillzStyle.fullStyles.fontSizeH3.fontSize
    : SkillzStyle.fullStyles.fontSizeH4.fontSize) *
    3 +
  TEXT_INPUT_PLATFORM_OFFSET;

/* Multi-purpose */

export const CHAT_MESSAGE_TYPE = {
  STANDARD: 0,
  INVITE: 1,
  JOIN: 2,
  NUDGE: 3,
};

export const ChatEntryPoint = {
  /* Current Implementation */
  BAR_LIVESTREAM: 'BarLiveStream',
  /* ChatBar without live stream content */
  BAR_NO_LIVE_STREAM: 'BarNoLiveStream',
  /* No ChatBat and with chat icon on top besides skillz powered */
  NO_BOTTOM_BAR: 'NoBottomBar',
  /* ChatBar with blurred live stream message */
  BLURRED_BOTTOM_BAR: 'BlurredBottomBar',
};
